<template>
  <div class="warehouse-form">
    <div class="warehouse-section-heading">
      <div class="warehouse-section-heading__icon"><i class="fas fa-warehouse"></i></div>
      <div><span>Data gudang</span><h2>Informasi dan rak penyimpanan</h2><p>Lengkapi identitas gudang serta daftar rak di dalamnya.</p></div>
    </div>
    <b-form class="warehouse-form__fields" @submit.stop.prevent="formOnsubmit">
      <!-- Name input -->
      <b-form-group
        class="warehouse-form__field warehouse-form__field--wide"
        id="input-group-name"
        label="Nama:"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="form.name"
          placeholder="Nama Gudang"
        ></b-form-input>
        <small class="text-danger">{{ error.name }}</small>
      </b-form-group>

     
      <!-- Description input -->
      <b-form-group id="input-group-address" class="warehouse-form__field">
        <label for="input-address">Alamat: <em class="text-muted">opsional</em></label>
        <b-form-textarea
          id="input-address"
          v-model="form.address"
          placeholder="Alamat"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.address }}</small>
      </b-form-group>

       <!-- Description input -->
      <b-form-group id="input-group-description" class="warehouse-form__field">
        <label for="input-description">Keterangan: <em class="text-muted">opsional</em></label>
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="Keterangan"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.description }}</small>
      </b-form-group>

      <section class="warehouse-form__rack-section">
        <div class="warehouse-form__rack-heading">
          <div><span>Pengaturan rak</span><h3>Daftar rak gudang</h3><p>Tambahkan nama atau nomor rak untuk memudahkan penempatan stok.</p></div>
          <strong>{{ data_rack.length }}</strong>
        </div>

        <b-form-group id="input-group-batch-no" class="warehouse-form__rack-input">
          <div class="warehouse-form__rack-control">
              <b-form-input
                id="input-batch-no"
                v-model="rack_form.name"
                placeholder="Nama / No Rak"
              >
              </b-form-input>
              <b-button
                size="sm"
                class="btn-info"
                v-b-tooltip.hover
                title="Tambah Rak"
                type="button"
                @click="setRack"
                ><i class="fas fa-plus px-0"></i
              ></b-button>
          </div>
          <small class="text-danger">{{ error_rack.name }}</small>
        </b-form-group>

      <div class="warehouse-form__rack-table">
        <table class="table">
          <tr>
            <th>#</th>
            <th>Nama / No Rak</th>
            <th>Aksi</th>
          </tr>
          <tr v-for="(btc,index) in data_rack" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ btc.name }}</td>
            <td>
              <b-button
                size="sm"
                class="btn-danger"
                v-b-tooltip.hover
                title="Hapus"
                type="button"
                v-if="purpose == 'add'"
                @click="removeRack(btc.id)"
                ><i class="fas fa-trash px-0"></i
              ></b-button>
              <b-button
                size="sm"
                class="btn-danger"
                v-b-tooltip.hover
                title="Hapus"
                type="button"
                v-if="purpose == 'edit'"
                @click="removeEditRack(btc.id)"
                ><i class="fas fa-trash px-0"></i
              ></b-button>
            </td>
          </tr>
        </table>
      </div>
      </section>

      <!-- Submit & Cancel button -->
      <div class="warehouse-form__actions">
      <b-button
        type="submit"
        variant="primary"
      ><i class="fas fa-save mr-2"></i>Simpan perubahan</b-button>
      <b-button
        type="button"
        class="ml-2"
        variant="default"
        @click="$router.push('/masters/warehouses')"
      >
        <i class="fas fa-arrow-left mr-2"></i>Kembali
      </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {
  props: {
    form: Object,
    purpose: String,
    route: String,
  },

  data() {
    return {
      // Error
      error: {
        name: "",
        address:"",
        description: "",
      },
      error_rack:{
        name:"",
      },
      // data
      data_rack:[],
      rack_form:{
        id:"",
        name:"",
      },
    


    };
  },

  methods: {
    // async getPolyclinics() {
    //   let response = await module.setSelectOption('polyclinics')
    //   if (response.state == 'success') {
    //     this.polyclinics = response.data
    //     this.polyclinics.push({ text: "Pilih Poliklinik", value: null, disabled: true })
    //   }
    // },

    async setRack() {
    //  console.log(this.rack_form.name);

      if(this.purpose == "add"){
        if (this.rack_form.name == "") {
            this.error_rack.name = "Nama tidak boleh kosong";
        } else {
          this.rack_form.id = this.data_rack.length+1
          this.error_rack.name = "";
          let clone = {...this.rack_form} ;
          this.data_rack.push(clone);
        }
      }else{
        this.rack_form.id = this.$route.params.id
        let response = await module.submit(this.rack_form, "warehouses-rack" );

        if (response) {
          this.getRack()
        }
      }

      this.rack_form.name = ""
    },

    

    removeRack($id) {
      let a;
      for (a = 0; a < this.data_rack.length; a++) {
        if (this.data_rack[a].id == $id) {

          this.data_rack.splice(a, 1);
        }
      }
    },
    
    async removeEditRack(id) {
      let result = await module.delete("warehouse-rack/delete/" + id);
      if (result) {
        this.getRack()
      }
    },

    async getRack() {
      this.data_rack = await module.get('warehouses-rack/' + this.$route.params.id)
    },

    async formOnsubmit() {
      // merge data
      let rack = JSON.stringify(this.data_rack)
      this.form.rack = rack 

      // Make Request
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/masters/warehouses");
      }
    },
  },
  mounted() {
 //   this.getBuildingOptions()
    if(this.purpose == "edit"){
      this.getRack()
    }
  }
};
</script>

<style>
</style>
